import { RealTimeComponent } from './../real-time/real-time.component';
import { OcorrenceDetailsComponent } from './../ocorrences/ocorrence-details/ocorrence-details.component';
import { OcorrenceListComponent } from './../ocorrences/ocorrence-list/ocorrence-list.component';
import { UserManagementComponent } from './../user/user-management/user-management.component';
import { UserDetailComponent } from './../user/user-detail/user-detail.component';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { TrialAccessComponent } from './trial-access/trial-access.component';
import { NgModule } from '@angular/core';
import { BusinessComponent } from '../business/business.component';
import { UserChangePasswordComponent } from '../user/user-change-password/user-change-password.component';
import { EmergenciesListComponent } from '../real-time/emergencies-list/emergencies-list.component';

const routes: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'user/detail', component: UserDetailComponent },
	{ path: 'user/change-password', component: UserChangePasswordComponent },
	{ path: 'manage-users', component: UserManagementComponent },
	{ path: 'ocurrences', component: OcorrenceListComponent },
	{ path: 'ocurrences-details/:id', component: OcorrenceDetailsComponent },
	{ path: 'real-time', component: RealTimeComponent },
	{ path: 'real-time/emergencies', component: EmergenciesListComponent },
	{ path: 'business', component: BusinessComponent },
	{ path: 'trial-access', component: TrialAccessComponent },
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class HomeRoutingModule {}
